<template>
  <v-card flat>
    <v-card-title>
      <v-icon class="mr-2">mdi mdi-face-mask-outline</v-icon>
      Paineilmalaitehuolto
      <v-spacer />
    </v-card-title>
    <v-divider />
    <v-card-text>
      <h3>
        Käytön jälkeisen huollon saa tehdä vain savusukelluskurssin suorittanut
        henkilö!
      </h3>
      <h4>
        Jokaisesta huolletusta paineilmalaitteesta tulee tehdä uusi merkintä
        alapuolella
      </h4>
      <ol class="mt-5">
        <li>
          <strong>Henkilösuojainten käyttö</strong>
          <ul>
            <li>Hengityksen suojain</li>
            <li>Suojakäsineet</li>
            <li>Silmäsuojus</li>
            <li>Kuulonsuojaus painepesuria käytettäessä</li>
          </ul>
        </li>
        <li>
          <strong>Puhdistus ja kuivaus</strong>
          <ul>
            <li>Raakapesu paineistettuna (pesuaine + varovainen pesu)</li>
            <li>
              Kasvo-osan pesu (saa irroittaa vain liekkisuojan ja
              sisäkasvo-osan)
            </li>
            <li>Hengitysventtiilin pyyhintä</li>
            <li>Pullon suojapussin pesu</li>
            <li>
              Selkälevyn, kasvo-osan ja hengitysventtiilin kuivaus kaapissa
            </li>
          </ul>
        </li>
        <li>
          <strong>Käyttökuntoon laittaminen</strong>
          <ul>
            <li>Kasaaminen (sama juokseva numero sl+hv+k-o)</li>
            <li>Puhdas suojapussi pulloon</li>
            <li>Hihnojen löysääminen</li>
          </ul>
        </li>
        <li>
          <strong>Toimintakuntotarkastus</strong>
          <ul>
            <li>Hihnaston ja letkuston silmämääräinen tarkastus</li>
            <li>Pullopaine (oltava yli 250 bar)</li>
            <li>Tiiveyskoe (+/- 10 bar / min)</li>
            <li>Kasvo-osan tiiveys ja uloshengitysventtiilin toiminta</li>
            <li>Kasvo-osan pikakiinnikkeiden kunto ja toiminta</li>
            <li>Pillivaroittimen toiminta</li>
          </ul>
        </li>
        <li>
          <strong>Sijoittaminen autoon</strong>
          <ul>
            <li>Laitekierto 511 -> 5112</li>
            <li>Sijoitus oikein telineeseen, että on puettavissa</li>
            <li>Kasvo-osan sijoitus pidikkeeseen ulkopuoli päin takaseinää</li>
          </ul>
        </li>
      </ol>
    </v-card-text>
    <v-divider />
    <v-card-text>
      <v-data-table
        :items="filteredPaineilmalaiteHuoltoData"
        :headers="paineilmalaiteHeaders"
        :loading="loadingPaineilmalaiteHuoltoData"
      >
        <template v-slot:top>
          <v-row no-gutters>
            <v-spacer />
            <v-btn
              color="primary"
              @click="openPaineilmalaiteHuoltoDialog"
              rounded
              small
            >
              <v-icon>mdi mdi-plus</v-icon> Uusi merkintä
            </v-btn>
          </v-row>
        </template>
        <template v-slot:item.form="{ item }">
          <v-chip :color="item._color" class="mb-2 mt-1" small>
            {{
              item._color === "error"
                ? "Puutteellinen"
                : item._color === "warning"
                ? "Huomioita"
                : "OK"
            }}
          </v-chip>
        </template>
        <template v-slot:item.notices="{ item }">
          {{ item.notices }}
        </template>
        <template v-slot:item.date="{ item }">
          {{ $formatDate(item.date) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="editPaineilmalaiteHuolto(item)">
            <v-icon>mdi mdi-pencil</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
    <v-divider />
    <v-card-text>
      <PaineilmalaiteHuoltoDialog
        ref="paineilmalaiteHuoltoDialog"
        @close="getPaineilmalaiteHuoltoData"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import PaineilmalaiteHuoltoDialog from "@/components/PaineilmalaiteHuoltoDialog.vue";
import { firestore as db } from "@/plugins/firebase.app";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy as orderByFirestore,
} from "firebase/firestore";
import { orderBy } from "lodash";

export default {
  name: "PaineilmalaitehuoltoView",

  components: {
    PaineilmalaiteHuoltoDialog,
  },
  data() {
    return {
      loadingPaineilmalaiteHuoltoData: false,
      paineilmalaiteHuoltoDialogOpen: false,
      paineilmalaiteHuoltoData: [],
      paineilmalaiteHeaders: [
        { text: "Päivämäärä", value: "date" },
        { text: "Laite", value: "device" },
        { text: "Paine", value: "pressure" },
        { text: "Huoltaja", value: "createdBy.user" },
        { text: "Tila", value: "form" },
        { text: "Huomiot", value: "notices" },
        { text: "", value: "actions", width: 50 },
      ],
    };
  },

  computed: {
    filteredPaineilmalaiteHuoltoData() {
      return orderBy(
        this.paineilmalaiteHuoltoData.map((p) => {
          if (p.form?.some((f) => f.type === null && f.done === 0)) {
            p._color = "error";
          } else if (p.form?.some((f) => f.type === null && f.done === 1)) {
            p._color = "warning";
          } else {
            p._color = "success";
          }
          p.pressure = p.form?.find(
            (f) => f.type === "pressure_select"
          )?.pressure;
          return p;
        }),
        ["date", "createdAt"],
        ["desc", "desc"]
      );
    },
  },

  mounted() {
    this.getPaineilmalaiteHuoltoData();
  },
  methods: {
    async getPaineilmalaiteHuoltoData() {
      this.loadingPaineilmalaiteHuoltoData = true;
      try {
        const q = query(
          collection(db, "paineilmalaitehuolto"),
          where("deleted", "==", false),
          orderByFirestore("date", "desc")
        );
        const querySnapshot = await getDocs(q);
        this.paineilmalaiteHuoltoData = [];
        querySnapshot.forEach((doc) => {
          this.paineilmalaiteHuoltoData.push({
            id: doc.id,
            ...doc.data(),
          });
        });
      } catch (error) {
        console.error("Virhe paineilmalaitehuoltotietojen haussa:", error);
        this.$emit(
          "show-snackbar",
          "Virhe tietojen haussa: " + error.message,
          "error"
        );
      }
      this.loadingPaineilmalaiteHuoltoData = false;
    },

    openPaineilmalaiteHuoltoDialog() {
      this.$refs.paineilmalaiteHuoltoDialog.open();
    },
    editPaineilmalaiteHuolto(item) {
      this.$refs.paineilmalaiteHuoltoDialog.open(item);
    },
  },
};
</script>

<style scoped>
.v-card-title {
  font-weight: 500;
}

.v-alert {
  border-radius: 8px;
}

ul {
  padding-left: 20px;
}

ul li {
  margin-bottom: 4px;
}
</style>
